




import { Link } from "react-router-dom";
import './StoriesStyles/CarlKlinck.css'
import './StoriesStyles/GeneralStoryStyle.css'


function CarlKlinck() {
    

    return (
        <div>
            <br></br>

            <Link to="/stories"><button className="BackButton">Back To Stories</button></Link>

            <h2> Carl Frederick Klinck </h2>

            

            <h4>Early Life and Background</h4>

            <p className="ArticleParagraph">
            Carl Frederick Klinck was born here in Elmira, Ontario March 24th 1908. He graduated from Waterloo College(now Wilfred Laurier University) at the age of nineteen. 
            He would go on to earn his M.A. from from Columbia University.  He would go on to teach English at Waterloo College where he would eventually become the Dean. 
            He would also take on various other academic roles.
            </p>

            <br></br>
            <br></br>

            <h4>Work and Contributions</h4>

            <p className="ArticleParagraph">
            When Carl was going through school it was thought that Canada, having only been confederated in 1867, didn’t really have a literary history of it’s own. Carl Klinck,
            through his extensive research, prolific writing and great efforts would change just that. His work helped uncover and assign authorship to many works from pre-confederation 
            and early Canada to help establish Canadian literary traditions. Not only did he help to bring forward these historical works, but he also performed extensive research
            on the people and personalities behind them. He wrote several landmark autobiographies highlighting Canadians with a strong contribution to our literary history such as
            Edwin J. Pratt, William “Tiger” Dunlop and Robert Service. He also published several collections of historical literature along with this biographical information that
            helped to expand understanding of and respect for Canadian literature as an academic subject.
            </p>

            <br></br>
            <br></br>

            <h4>Recognition and Later Life</h4>

            <p className="ArticleParagraph">
            For his groundbreaking work, Carl Klinck was made an officer of the Order of Canada in 1973 and earned the Royal Society of Canada’s Lorne Pierce medal in 1978. His works are
            still invaluable academic sources to this day and Canadian Literature is now taught in schools and respected as an academic subject in no small part due to his tireless
            efforts. He continue writing until he passed away on October 22nd, 1990 in London, Ontario.
            </p>

            <br></br>
            <br></br>
            

            <h4>Sources</h4>

            <p className="SourceText">General Background: <a href="https://www.thecanadianencyclopedia.ca/en/article/carl-frederick-klinck">Carl Frederick Klinck: Canadian Encyclopedia</a></p>
            <br></br>
            <p className="SourceText">Contributions:  <a href="https://canadianpoetry.org/volumes/vol30/conron.html">Carl F. Klinck, Pathfinder in Canadian Literature: Canadian Poetry</a></p>
            <br></br>
            <p className="SourceText">Order of Canada: <a href="https://www.gg.ca/en/honours/recipients/146-14326">Mr. Carl Klinck: Govenor General of Canada</a></p>
            <br></br>
            <p className="SourceText">Royal Society of Canada Lorne Pierce award: <a href="https://rsc-src.ca/en/awards-excellence/past-award-winners">Past Award Winners: Royal Society of Canada</a></p>

        </div>
    );
}



export default CarlKlinck;
